<template>
  <PageWrapper>
    <template #content>
      <div>
        <DashNotification
          v-for="notification in site_notifications"
          :key="notification.id"
          v-bind="{
            pk: notification.id,
            created: notification.start,
            urgency: notification.variant,
          }"
        >
          <template #title>{{ notification.header }}</template>
          <p v-html="notification.message" />
        </DashNotification>
        <div class="container max-w-6xl mx-auto p-8 pb-24">
          <StatSection id="dashboard-stats" />
          <div class="mt-12">
            <h2 class="text-2xl font-semibold text-gray-700">
              Recent Activity
            </h2>
            <RecentActivity class="mt-2" />
          </div>
        </div>
      </div>
      <Onboarding page="dashboard" />
    </template>
  </PageWrapper>
</template>

<script setup>
import { storeToRefs } from "pinia";

import { onMounted } from "vue";
import DashNotification from "@/components/DashNotification.vue";
import Onboarding from "@/components/Onboarding.vue";
import PageWrapper from "@/components/PageWrapper.vue";
import RecentActivity from "@/components/RecentActivity.vue";
import StatSection from "@/components/StatSection.vue";
import useSiteNotificationStore from "@/stores/site-notifications";

const siteNotificationStore = useSiteNotificationStore();
const { site_notifications } = storeToRefs(siteNotificationStore);

onMounted(async () => {
  await siteNotificationStore.getSiteNotifications();
});
</script>
